import React, { useState } from 'react';
import styled from 'styled-components';

import { Dropdown as AntDropdown } from 'antd';
import { headerRoutes } from '@/routes/routes';
import { RouteChildType, RouteType } from '@/models/RouteType';
import { NavLink } from 'react-router-dom';
import { NavArrow } from '@monavate/ui-core';
import PermissionChecker from '@/components/PermissionChecker/PermissionChecker';

const Wrapper = styled.div`
    display: flex;
    gap: 24px;
    font-family: 'Poppins', serif;
`;

const Item = styled(NavLink)<{ Collapsed?: boolean }>`
    color: ${(props) => props.theme['Content/primary']};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 16px;
    padding: 8px 18px 8px 16px;
    height: 24px;
    font-size: 14px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    text-decoration: none;

    &:hover {
        background: ${(props) => props.theme['Surface/secondary']};
        color: ${(props) => props.theme['Content/secondary']};
    }

    &.active {
        background: ${(props) => props.theme['Surface/secondary']};
        color: ${(props) => props.theme['Content/secondary']};
        font-weight: 500;
    }

    &:last-child {
        margin-right: 0;
    }
`;

const MenuIcon = styled.span`
    margin: 4px 4px 4px 0;
    padding-top: 5px;
    font-weight: 400;
`;

export const NavMenuDropdown = styled(AntDropdown)``;

const DrobdownMenuContainer = styled.div`
    border-radius: 0;
    border: 1px solid ${(props) => props.theme['Borders/quiet']};
    background: ${(props) => props.theme['Surface/page']};
`;

const RouteChild = styled(NavLink)`
    font-weight: 400;
    line-height: 22px;
    text-decoration: none;
    display: flex;
    height: 32px;
    padding: 5px 16px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    cursor: pointer;
    min-width: 295px;
    color: ${(props) => props.theme['Content/primary']};
    font-size: 14px;
    font-style: normal;
    &:hover {
        background: ${(props) => props.theme['Surface/secondary']};
        color: ${(props) => props.theme['Content/secondary']};
    }
    &.active {
        background: ${(props) => props.theme['Surface/secondary']};
        color: ${(props) => props.theme['Content/secondary']};
        font-weight: 500;
    }
`;

const configureRouteWithChildren = (children: RouteChildType[]): any => {
    return children.map((child, index) => (
        <PermissionChecker
            key={index}
            allowedPermissions={child?.allowedPermissions}
            VACRequiredPermissions={child?.VACRequiredPermissions}
        >
            <RouteChild key={index} to={child.path}>
                {child.icon}
                {child.name}
            </RouteChild>
        </PermissionChecker>
    ));
};

const isChildMenuInHref = (targetPath: string, childrenArray: RouteChildType[]): boolean => {
    for (const item of childrenArray) {
        if (item.path === targetPath) {
            return true;
        }
    }
    return false;
};

export const TopMenuItems = () => {
    const pathnameUrl = window.location.pathname;
    const [visibleRoutes, setVisibleRoutes] = useState(() => headerRoutes);
    const [openDropDown, setOpenDropDown] = useState(false);
    return (
        <Wrapper>
            {visibleRoutes.map((category: RouteType, index) =>
                category.children ? (
                    <PermissionChecker
                        key={index}
                        allowedPermissions={category?.allowedPermissions}
                        VACRequiredPermissions={category?.VACRequiredPermissions}
                    >
                        <NavMenuDropdown
                            popupRender={() => (
                                <DrobdownMenuContainer>
                                    {category.children &&
                                        configureRouteWithChildren(category.children)}
                                </DrobdownMenuContainer>
                            )}
                            onOpenChange={(open) => setOpenDropDown(open)}
                            key={index}
                        >
                            <Item
                                key={index}
                                to={category.children[0].path}
                                className={
                                    isChildMenuInHref(pathnameUrl, category.children)
                                        ? 'active'
                                        : ''
                                }
                            >
                                <MenuIcon>{category.icon}</MenuIcon>
                                {category.id}
                                <NavArrow collapsed={openDropDown} />
                            </Item>
                        </NavMenuDropdown>
                    </PermissionChecker>
                ) : (
                    <PermissionChecker
                        key={index}
                        allowedPermissions={category?.allowedPermissions}
                        VACRequiredPermissions={category?.VACRequiredPermissions}
                    >
                        <Item to={category.path}>
                            <MenuIcon>{category.icon}</MenuIcon>
                            {category.id}
                        </Item>
                    </PermissionChecker>
                ),
            )}
        </Wrapper>
    );
};
